<div class="flex flex-col gap-4">
	<h4 class="font-medium text-lg m-0">Fee Placement</h4>

	<app-direction-of-fee-dropdown
		[currentDirectionOfFee]="settingsSignal()?.location"
		label="Display Line Item(s) In"
		fieldToUpdate="{{ firestoreDefaultSettingsPath }}.location"
		intercomAttr="treefort-display-amount-setting"
	/>

	<app-input
		[required]="true"
		type="cents"
		[ngModel]="settingsSignal()?.amount"
		(debounce)="setAmount($event)"
		label="Fee Amount (Per IDV Report Completed)"
		[testHook]="testHooks.IdvFeeAmountInput"
	/>
</div>
